// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually

import React from 'react';

const IconCustomClose = (
  {
    size,
    style,
    ...rest
  }: React.HTMLAttributes<SVGElement> & { size?: number } /*#__PURE__*/,
) =>
  React.createElement(
    'svg',
    {
      style: { width: size, height: size, ...style },
      ...rest,
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      xmlns: 'http://www.w3.org/2000/svg',
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        clipPath: 'url(#clip0_1390_629)',
      },
      /*#__PURE__*/ React.createElement('path', {
        d: 'M1.33325 14.6663L14.6666 1.33301',
        stroke: 'currentColor',
        strokeWidth: '2',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M14.6666 14.6663L1.33325 1.33301',
        stroke: 'currentColor',
        strokeWidth: '2',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
      }),
    ),
    /*#__PURE__*/ React.createElement(
      'defs',
      null,
      /*#__PURE__*/ React.createElement(
        'clipPath',
        {
          id: 'clip0_1390_629',
        },
        /*#__PURE__*/ React.createElement('rect', {
          width: '16',
          height: '16',
          fill: 'white',
        }),
      ),
    ),
  );

export { IconCustomClose };
